import { useEffect } from 'react';
import { useParams, useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { ssoLogin } from '../../redux/actions/authActions';

const SsoLogin = () => {
    const { ssoToken } = useParams();
    const dispatch = useDispatch();
    const navigate = useNavigate();

    useEffect(() => {
        const authenticateWithSSO = async () => {
            try {
                if (!ssoToken) {
                    navigate('/login');
                    return;
                }
                const success = await dispatch(ssoLogin(ssoToken));
                
                if (success) {
                    navigate('/index');
                } else {
                    navigate('/login');
                }
            } catch (error) {
                console.error('SSO Login Error:', error);
                navigate('/login');
            }
        };

        authenticateWithSSO();
    }, [ssoToken, dispatch, navigate]);
};

export default SsoLogin;